import React, { useMemo,useState} from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { isEmail } from 'src/utils/validation';

import { EmailInput, PasswordInput, SubmitButton } from '../../components';
import { login } from '../../store/reducers/authSlice';



export const SignInScreen = () => {
  const dispatch = useAppDispatch();
  const { isLoginLoading } = useAppSelector((state) => state.auth);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const onEmailInputValidate = (value: string) => {
    if (!isEmail(value)) {
      return 'The value is not a valid email address';
    }
    return '';
  }

  const onPasswordInputValidate = (value: string) => {
    return value.length > 0 ? '' : "too short password";
  }

  const isFormValid = useMemo(() => {
    return !onEmailInputValidate(email) && !onPasswordInputValidate(password);
  }, [email, password]);

  const handleSubmit = (event: any) => {
    event.preventDefault();

    if (isFormValid) {
      dispatch(login({login: email, password}));
    }
  };

  return (
    <Box display="flex">
      <Box sx={{
        borderRadius: 4,
        paddingX: 4,
        maxWidth: 494,
        backgroundColor: 'white',
      }}>
        <Box
          sx={{
            marginTop: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box sx={{
            mb: 4
          }}>
            <img
              alt="Logo"
              width="40px"
              src="/images/logo.png"
            />
          </Box>
          <Box sx={{
            mb: 4
          }}>
            <Typography component="h1" variant="h2">
              Sign in
            </Typography>
          </Box>
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <EmailInput
              label="Email"
              id="email-input"
              name="email"
              initialValue={email}
              onChange={(value) => setEmail(value)}
              validationFn={onEmailInputValidate}
            />
            <PasswordInput
              label="Password"
              id="password-input"
              name="password"
              initialValue={password}
              onChange={(value) => setPassword(value)}
              validationFn={onPasswordInputValidate}
            />
            <Grid container>
              <Grid item xs>
                <Link href="/reset" variant="body2" underline="none">
                  Forgot password?
                </Link>
              </Grid>
            </Grid>
            <FormControlLabel
              control={<Checkbox value="remember" color="primary"/>}
              label="Keep me logged in"
            />
            <SubmitButton
              title="Sign In"
              type="submit"
              isLoading={isLoginLoading}
              size="large"
              fullWidth
              disableRipple
              disableElevation
              variant="contained"
              sx={{mt: 3, mb: 4}}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
